import Vue from 'vue'
import Router from 'vue-router'

import routes from './routes'
import {
  MEMBER_AREA_ROUTE_LOGIN,
  MEMBER_AREA_ROUTE_PET_PRODUCTS,
  MEMBER_AREA_ROUTE_PRODUCTS,
} from './routes-names'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: '/member-area/',
  routes,
  scrollBehavior(from, to) {
    const productsRoutes = [
      MEMBER_AREA_ROUTE_PET_PRODUCTS,
      MEMBER_AREA_ROUTE_PRODUCTS,
    ]

    if (
      productsRoutes.includes(from.name) &&
      productsRoutes.includes(to.name)
    ) {
      // FIXME: returning this object is useless & does not scroll to top
      return { y: 0, x: 0 }
    }

    // FIXME: remove this hack to scroll to top
    const element = document.getElementById('content')

    element?.scrollIntoView()

    // FIXME: returning this object is useless & does not scroll to top
    return { y: 0, x: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (from.query.id && !to.query.id) {
    if (to.name === MEMBER_AREA_ROUTE_LOGIN) {
      next()
      return
    }

    if (from.path === to.path) {
      next(false)
      return
    }

    next({
      path: to.path,
      query: { ...to.query, id: from.query.id },
    })
    return
  }

  next()
})

export function createRouter() {
  return router
}
